export default __webpack_public_path__ + "static/Rahul-3e526033dc845ce311fbecdeffd89d71df25b8f1c0dbd92f0c2e7b8afd3ef0d6.svg";